// extracted by mini-css-extract-plugin
export default {"btnChangeResponsible":"referencesPull_btnChangeResponsible__Xn9IR","changeResponsible":"referencesPull_changeResponsible__djUDh"};